import { render, staticRenderFns } from "./Streak.vue?vue&type=template&id=4b584496&scoped=true&"
import script from "./Streak.vue?vue&type=script&lang=ts&"
export * from "./Streak.vue?vue&type=script&lang=ts&"
import style0 from "./Streak.vue?vue&type=style&index=0&id=4b584496&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b584496",
  null
  
)

export default component.exports